// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Project  {
    _originalTypeClassName = "Loom.BO.Project";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Project.translate = translateService;
}
this.ReportingPeriods = [];
this.Consortium = [];
this.WorkPackages = [];
this.Contracts = [];
this.Milestones = [];
this.ProjectReviews = [];
this.ProjectPaymentTerms = [];
this.Meetings = [];
this.Trips = [];
this.Id = null;
this.AccountingCode = null;
this.Acronym = null;
this.ProjectNumber = null;
this.Title = null;
this.CallIdentifier = null;
this.Topic = null;
this.Programme = null;
this.FundingScheme = null;
this.ECStatus = null;
this.DGAgencyJTI = null;
this.Service = null;
this.StartDate = null;
this.Duration = null;
this.EndDate = null;
this.CurrentMonth = null;
this.OverallCosts = null;
this.EUContribution = null;
this.NumberOfParticipants = null;
this.DomainTag = null;
this.LastPlanCommitedDate = null;
this.Progress = null;
this.ProjectEffort = null;
this.ClickUpFolderId = null;
this.Active = false;
this.CreatedOn = null;
this.IsLumpSum = false;
this.MyBeneficiaries = null;
this.Sponsors = null;
this.ContractInForce = null;
this.ContractInForceDate = null;
this.CoordinatorOrgId = null;
this.TopicOpenDate = null;
this.TopicCloseDate = null;
this.TopicUrl = null;
this.IndirectCostsPercentage = null;
this.IndirectCostsBase = null;
this.IsEUProject = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
AccountingCode:any;
Acronym:any;
ProjectNumber:any;
Title:any;
CallIdentifier:any;
Topic:any;
Programme:any;
FundingScheme:any;
ECStatus:any;
DGAgencyJTI:any;
Service:any;
StartDate:any;
Duration:any;
EndDate:any;
CurrentMonth:any;
OverallCosts:any;
EUContribution:any;
NumberOfParticipants:any;
DomainTag:any;
LastPlanCommitedDate:any;
Progress:any;
ProjectEffort:any;
ClickUpFolderId:any;
Active:any;
CreatedOn:any;
IsLumpSum:any;
MyBeneficiaries:any;
Sponsors:any;
ContractInForce:any;
ContractInForceDate:any;
CoordinatorOrgId:any;
TopicOpenDate:any;
TopicCloseDate:any;
TopicUrl:any;
IndirectCostsPercentage:any;
IndirectCostsBase:any;
IsEUProject:any;
ProjConfiguration:any;
ReportingPeriods:any;
Organisation:any;
Consortium:any;
AutoPlanConfig:any;
WorkPackages:any;
Contracts:any;
Milestones:any;
ProjectReviews:any;
CreatedBy:any;
ProjectPaymentTerms:any;
Meetings:any;
Trips:any;
static setProjConfiguration = ($this, value) => {
var oldValue = $this.ProjConfiguration;
$this.ProjConfiguration = value;
if (value != null) {
if (oldValue != null && oldValue.Project != null) { oldValue.Project = null; }
if ($this.ProjConfiguration.Project !== $this) {
Domain.ProjConfiguration.setProject(value, $this);
}
}
}
static setReportingPeriods = ($this, items) => {
                if (items == null) items = [];
                if ($this.ReportingPeriods == null) $this.ReportingPeriods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ReportingPeriods.length > 0) {
                    Domain.Project.removeReportingPeriods($this, $this.ReportingPeriods[0]);
                }

                Domain.Project.addManyReportingPeriods($this, copyItems);
            }
static addManyReportingPeriods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addReportingPeriods($this, items[i]);
                }
            }
static addReportingPeriods = ($this, item) => {
                if ($this.ReportingPeriods == null) $this.ReportingPeriods = [];
                if (item == null || $this.ReportingPeriods.indexOf(item) > -1) return;
                $this.ReportingPeriods.push(item);
if (item.Project != $this) {
Domain.ReportingPeriod.setProject(item, $this);
}
}
static addRangeReportingPeriods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addReportingPeriods($this, item));
            }
static removeReportingPeriods = ($this, item) => {
                if ($this == null || $this.ReportingPeriods == null || $this.ReportingPeriods.indexOf(item) === -1) return;
                var _index = $this.ReportingPeriods.indexOf(item);
                $this.ReportingPeriods.splice(_index, 1);
item.Project = null;
}
static clearReportingPeriods = ($this) => { $this.ReportingPeriods = null; }
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
if (oldValue != null) {
Domain.Organisation.removeProjects(oldValue, $this);
}
Domain.Organisation.addProjects(value, $this);
}
}
static setConsortium = ($this, items) => {
                if (items == null) items = [];
                if ($this.Consortium == null) $this.Consortium = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Consortium.length > 0) {
                    Domain.Project.removeConsortium($this, $this.Consortium[0]);
                }

                Domain.Project.addManyConsortium($this, copyItems);
            }
static addManyConsortium = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addConsortium($this, items[i]);
                }
            }
static addConsortium = ($this, item) => {
                if ($this.Consortium == null) $this.Consortium = [];
                if (item == null || $this.Consortium.indexOf(item) > -1) return;
                $this.Consortium.push(item);
if (item.Project != $this) {
Domain.ProjectParticipant.setProject(item, $this);
}
}
static addRangeConsortium = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addConsortium($this, item));
            }
static removeConsortium = ($this, item) => {
                if ($this == null || $this.Consortium == null || $this.Consortium.indexOf(item) === -1) return;
                var _index = $this.Consortium.indexOf(item);
                $this.Consortium.splice(_index, 1);
item.Project = null;
}
static clearConsortium = ($this) => { $this.Consortium = null; }
static setAutoPlanConfig = ($this, value) => {
var oldValue = $this.AutoPlanConfig;
$this.AutoPlanConfig = value;
if (value != null) {
}
}
static setWorkPackages = ($this, items) => {
                if (items == null) items = [];
                if ($this.WorkPackages == null) $this.WorkPackages = [];

                const copyItems = Common.cloneObject(items);

                while ($this.WorkPackages.length > 0) {
                    Domain.Project.removeWorkPackages($this, $this.WorkPackages[0]);
                }

                Domain.Project.addManyWorkPackages($this, copyItems);
            }
static addManyWorkPackages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addWorkPackages($this, items[i]);
                }
            }
static addWorkPackages = ($this, item) => {
                if ($this.WorkPackages == null) $this.WorkPackages = [];
                if (item == null || $this.WorkPackages.indexOf(item) > -1) return;
                $this.WorkPackages.push(item);
if (item.Project != $this) {
Domain.WorkPackage.setProject(item, $this);
}
}
static addRangeWorkPackages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addWorkPackages($this, item));
            }
static removeWorkPackages = ($this, item) => {
                if ($this == null || $this.WorkPackages == null || $this.WorkPackages.indexOf(item) === -1) return;
                var _index = $this.WorkPackages.indexOf(item);
                $this.WorkPackages.splice(_index, 1);
item.Project = null;
}
static clearWorkPackages = ($this) => { $this.WorkPackages = null; }
static setContracts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Contracts == null) $this.Contracts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Contracts.length > 0) {
                    Domain.Project.removeContracts($this, $this.Contracts[0]);
                }

                Domain.Project.addManyContracts($this, copyItems);
            }
static addManyContracts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addContracts($this, items[i]);
                }
            }
static addContracts = ($this, item) => {
                if ($this.Contracts == null) $this.Contracts = [];
                if (item == null || $this.Contracts.indexOf(item) > -1) return;
                $this.Contracts.push(item);
if (item.Project != $this) {
Domain.ProjectContract.setProject(item, $this);
}
}
static addRangeContracts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addContracts($this, item));
            }
static removeContracts = ($this, item) => {
                if ($this == null || $this.Contracts == null || $this.Contracts.indexOf(item) === -1) return;
                var _index = $this.Contracts.indexOf(item);
                $this.Contracts.splice(_index, 1);
item.Project = null;
}
static clearContracts = ($this) => { $this.Contracts = null; }
static setMilestones = ($this, items) => {
                if (items == null) items = [];
                if ($this.Milestones == null) $this.Milestones = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Milestones.length > 0) {
                    Domain.Project.removeMilestones($this, $this.Milestones[0]);
                }

                Domain.Project.addManyMilestones($this, copyItems);
            }
static addManyMilestones = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addMilestones($this, items[i]);
                }
            }
static addMilestones = ($this, item) => {
                if ($this.Milestones == null) $this.Milestones = [];
                if (item == null || $this.Milestones.indexOf(item) > -1) return;
                $this.Milestones.push(item);
if (item.Project != $this) {
Domain.Milestone.setProject(item, $this);
}
}
static addRangeMilestones = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addMilestones($this, item));
            }
static removeMilestones = ($this, item) => {
                if ($this == null || $this.Milestones == null || $this.Milestones.indexOf(item) === -1) return;
                var _index = $this.Milestones.indexOf(item);
                $this.Milestones.splice(_index, 1);
item.Project = null;
}
static clearMilestones = ($this) => { $this.Milestones = null; }
static setProjectReviews = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectReviews == null) $this.ProjectReviews = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectReviews.length > 0) {
                    Domain.Project.removeProjectReviews($this, $this.ProjectReviews[0]);
                }

                Domain.Project.addManyProjectReviews($this, copyItems);
            }
static addManyProjectReviews = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addProjectReviews($this, items[i]);
                }
            }
static addProjectReviews = ($this, item) => {
                if ($this.ProjectReviews == null) $this.ProjectReviews = [];
                if (item == null || $this.ProjectReviews.indexOf(item) > -1) return;
                $this.ProjectReviews.push(item);
if (item.Project != $this) {
Domain.ProjectReview.setProject(item, $this);
}
}
static addRangeProjectReviews = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addProjectReviews($this, item));
            }
static removeProjectReviews = ($this, item) => {
                if ($this == null || $this.ProjectReviews == null || $this.ProjectReviews.indexOf(item) === -1) return;
                var _index = $this.ProjectReviews.indexOf(item);
                $this.ProjectReviews.splice(_index, 1);
item.Project = null;
}
static clearProjectReviews = ($this) => { $this.ProjectReviews = null; }
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setProjectPaymentTerms = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectPaymentTerms == null) $this.ProjectPaymentTerms = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectPaymentTerms.length > 0) {
                    Domain.Project.removeProjectPaymentTerms($this, $this.ProjectPaymentTerms[0]);
                }

                Domain.Project.addManyProjectPaymentTerms($this, copyItems);
            }
static addManyProjectPaymentTerms = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addProjectPaymentTerms($this, items[i]);
                }
            }
static addProjectPaymentTerms = ($this, item) => {
                if ($this.ProjectPaymentTerms == null) $this.ProjectPaymentTerms = [];
                if (item == null || $this.ProjectPaymentTerms.indexOf(item) > -1) return;
                $this.ProjectPaymentTerms.push(item);
if (item.Project != $this) {
Domain.ProjectPaymentTerm.setProject(item, $this);
}
}
static addRangeProjectPaymentTerms = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addProjectPaymentTerms($this, item));
            }
static removeProjectPaymentTerms = ($this, item) => {
                if ($this == null || $this.ProjectPaymentTerms == null || $this.ProjectPaymentTerms.indexOf(item) === -1) return;
                var _index = $this.ProjectPaymentTerms.indexOf(item);
                $this.ProjectPaymentTerms.splice(_index, 1);
item.Project = null;
}
static clearProjectPaymentTerms = ($this) => { $this.ProjectPaymentTerms = null; }
static setMeetings = ($this, items) => {
                if (items == null) items = [];
                if ($this.Meetings == null) $this.Meetings = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Meetings.length > 0) {
                    Domain.Project.removeMeetings($this, $this.Meetings[0]);
                }

                Domain.Project.addManyMeetings($this, copyItems);
            }
static addManyMeetings = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addMeetings($this, items[i]);
                }
            }
static addMeetings = ($this, item) => {
                if ($this.Meetings == null) $this.Meetings = [];
                if (item == null || $this.Meetings.indexOf(item) > -1) return;
                $this.Meetings.push(item);
if (item.Project != $this) {
Domain.Meeting.setProject(item, $this);
}
}
static addRangeMeetings = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addMeetings($this, item));
            }
static removeMeetings = ($this, item) => {
                if ($this == null || $this.Meetings == null || $this.Meetings.indexOf(item) === -1) return;
                var _index = $this.Meetings.indexOf(item);
                $this.Meetings.splice(_index, 1);
item.Project = null;
}
static clearMeetings = ($this) => { $this.Meetings = null; }
static setTrips = ($this, items) => {
                if (items == null) items = [];
                if ($this.Trips == null) $this.Trips = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Trips.length > 0) {
                    Domain.Project.removeTrips($this, $this.Trips[0]);
                }

                Domain.Project.addManyTrips($this, copyItems);
            }
static addManyTrips = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Project.addTrips($this, items[i]);
                }
            }
static addTrips = ($this, item) => {
                if ($this.Trips == null) $this.Trips = [];
                if (item == null || $this.Trips.indexOf(item) > -1) return;
                $this.Trips.push(item);
if (item.Project != $this) {
Domain.Trip.setProject(item, $this);
}
}
static addRangeTrips = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Project.addTrips($this, item));
            }
static removeTrips = ($this, item) => {
                if ($this == null || $this.Trips == null || $this.Trips.indexOf(item) === -1) return;
                var _index = $this.Trips.indexOf(item);
                $this.Trips.splice(_index, 1);
item.Project = null;
}
static clearTrips = ($this) => { $this.Trips = null; }

static DurationInMonths($this: any): any{let count = 0;
let run = new Date(new Date($this?.StartDate)?.setHours(0, 0, 0, 0));
while ((new Date(run).getTime()) <= (new Date(new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0))).getTime()) && CLMS.Framework.Number.LessThan(() => count, () => 1000)) {run = (moment(run).add(1, "M")).toDate();count = Joove.Common.safeNumber(count) + Joove.Common.safeNumber(1);}
return count;
}
static GetActive($this: any): any{return Domain.Project.IsActiveOnDate($this, moment().toDate());
}
static GetContractInForce($this: any): any{return $this?.Contracts?.linq?.where((a) => a?.InForce)?.firstOrDefault(null)?.RefName;
}
static GetContractInForceDate($this: any): any{return $this?.Contracts?.linq?.where((a) => a?.InForce)?.firstOrDefault(null)?.DateSigned;
}
static GetCoordinatorOrgId($this: any): any{return Domain.Project.GetTheCoordinator($this, false)?.Organisation?.Id;
}
static GetCurrentMonth($this: any): any{return Domain.Project.GetProjectMonthByDate($this, new Date(new Date(moment().toDate())?.setHours(0, 0, 0, 0)));
}
static GetEndDate($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.Duration, () => 0))) {return null;}
if ((!(($this?.StartDate != null)))) {return null;}
return (moment((moment(new Date(new Date($this?.StartDate)?.setHours(0, 0, 0, 0))).add($this?.Duration, "M")).toDate()).add(-1, "d")).toDate();
}
static GetEUContribution($this: any): any{return $this?.Consortium?.linq?.sum((p) => p?.MaxGrantAmount);
}
static GetMonthDates($this: any, month: any): any{if (CLMS.Framework.Number.LessThan(() => month, () => 1)) {return null;}
let dt = (moment($this?.StartDate).add(Joove.Common.safeNumber(month) - Joove.Common.safeNumber(1), "M")).toDate();
let enddate = (moment((moment(dt).add(1, "M")).toDate()).add(-1, "d")).toDate();
return [new Date(new Date(dt)?.setHours(0, 0, 0, 0)), new Date(new Date(enddate)?.setHours(0, 0, 0, 0))];
}
static GetOverallCosts($this: any): any{return $this?.Consortium?.linq?.sum((p) => p?.TotalEstimatedEligibleCosts);
}
static GetProgress($this: any): any{if ((new Date($this?.EndDate).getTime()) <= (new Date(moment().toDate()).getTime())) {return 1;}
if ((new Date($this?.StartDate).getTime()) > (new Date(moment().toDate()).getTime())) {return 0;}
let totalDays = Joove.Common.dateDiff($this?.EndDate, $this?.StartDate)?.days;
let passedDays = Joove.Common.dateDiff(moment().toDate(), $this?.StartDate)?.days;
return (Joove.Common.cast((Joove.Common.safeNumber(passedDays) / Joove.Common.safeNumber(totalDays)), "number"));
}
static GetProjectMonthByDate($this: any, dt: any): any{if (!((dt != null))) {return null;}
if ((new Date(new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0))).getTime()) <= (new Date(new Date(new Date(dt)?.setHours(0, 0, 0, 0))).getTime())) {return $this?.Duration;}
if ((new Date(new Date(new Date($this?.StartDate)?.setHours(0, 0, 0, 0))).getTime()) > (new Date(new Date(new Date(dt)?.setHours(0, 0, 0, 0))).getTime())) {return 0;}
let monthsApart = Joove.Common.safeNumber((Joove.Common.safeNumber((moment(dt).month() + 1)) - Joove.Common.safeNumber((moment($this?.StartDate).month() + 1)))) + Joove.Common.safeNumber(12) * Joove.Common.safeNumber((Joove.Common.safeNumber(moment(dt).year()) - Joove.Common.safeNumber(moment($this?.StartDate).year())));
return Joove.Common.safeNumber(monthsApart) + Joove.Common.safeNumber(1);
}
static GetTheCoordinator($this: any, throwError: any): any{let coords = $this?.Consortium?.linq?.where((a) => a?.Role == Domain.BeneficiaryRole.Coordinator)?.toArray();
if (CLMS.Framework.Number.LessThanOrEqual(() => coords.length, () => 0) && throwError) {throw Error("No coordinators found for [" + $this?.Acronym + "]! Check the project's configuration!");}
if (CLMS.Framework.Number.GreaterThan(() => coords.length, () => 1) && throwError) {throw Error("Multiple coordinators found for [" + $this?.Acronym + "]! Check the project's configuration!");}
return coords?.linq?.where()?.firstOrDefault(null);
}
static GetWorkplanAsTree($this: any): any{let nodes = [];
let key = 1;
for (let _iwp = 0; _iwp < ($this?.WorkPackages == null ? 0 : $this?.WorkPackages.length); _iwp++) {let wp = $this?.WorkPackages[_iwp];let wpNode = new Domain.TreeNode();wpNode.key = key;key = Joove.Common.safeNumber(key) + Joove.Common.safeNumber(1);wpNode.label = wp?.FQN;wpNode.info = "WP";wpNode.wp_id = wp?.Id;nodes?.add(wpNode);for (let _itask = 0; _itask < (wp?.Tasks == null ? 0 : wp?.Tasks.length); _itask++) {let task = wp?.Tasks[_itask];let taskNode = new Domain.TreeNode();taskNode.key = key;key = Joove.Common.safeNumber(key) + Joove.Common.safeNumber(1);taskNode.label = task?.Caption;taskNode.info = "Task";taskNode.wp_id = wp?.Id;taskNode.task_id = task?.Id;wpNode?.children?.add(taskNode);for (let _isubtask = 0; _isubtask < (task?.SubTasks == null ? 0 : task?.SubTasks.length); _isubtask++) {let subtask = task?.SubTasks[_isubtask];let subtaskNode = new Domain.TreeNode();subtaskNode.key = key;key = Joove.Common.safeNumber(key) + Joove.Common.safeNumber(1);subtaskNode.label = subtask?.Caption;subtaskNode.info = "SubTask";subtaskNode.wp_id = wp?.Id;subtaskNode.task_id = task?.Id;subtaskNode.subtask_id = subtask?.Id;taskNode?.children?.add(subtaskNode);}}}
return nodes;
}
static GetWorkplanSimplified($this: any): any{let id = 1;
let nodes = [];
for (let _iwp = 0; _iwp < ($this?.WorkPackages == null ? 0 : $this?.WorkPackages.length); _iwp++) {let wp = $this?.WorkPackages[_iwp];let wpNode = new Domain.WorkplanItem();wpNode.Id = id;id = Joove.Common.safeNumber(id) + Joove.Common.safeNumber(1);wpNode.WpId = wp?.Id;wpNode.Type = "WP";wpNode.ItemNumber = wp?.WPNumber;wpNode.Name = wp?.Name;wpNode.StartMonth = wp?.StartMonth;wpNode.EndMonth = wp?.EndMonth;wpNode.DescriptionOfWork = wp?.DescriptionOfWork;wpNode.Objectives = wp?.Objectives;wpNode.TotalParentEffort = $this?.ProjectEffort;wpNode.TotalPersonMonthsBudgeted = wp?.TotalPersonMonthsBudgeted;wpNode.Percentage = wp?.WPPercentage;wpNode.ClickUpListId = wp?.ClickUpListId;wpNode.ClickUpLink = wp?.ClickUpLink;wpNode.ItemNumberInt = wp?.WPNumberInt;if ((CLMS.Framework.Number.GreaterThan(() => wp.Participations.length, () => 0))) {wpNode.Leader = wp?.Participations?.linq?.where((a) => a?.IsLeader)?.firstOrDefault(null)?.Participant?.Caption;wpNode.Participants = CLMS.Framework.String.Join(", ", wp?.Participations?.linq?.select((a) => a?.Participant?.Caption)?.toArray());}wpNode.Percentage = wp?.WPPercentage;wpNode.label = wp?.FQN;wpNode.StartDate = wp?.StartDate;wpNode.EndDate = wp?.EndDate;wpNode.ItemNumberInt = wp?.WPNumberInt;Domain.WorkplanItem.setWorkAssignments(wpNode, wp?.Participations?.linq?.orderBy((a) => a?.Participant?.Caption)?.toArray());nodes?.add(wpNode);for (let _itask = 0; _itask < (wp?.Tasks == null ? 0 : wp?.Tasks.length); _itask++) {let task = wp?.Tasks[_itask];let taskNode = new Domain.WorkplanItem();taskNode.Id = id;id = Joove.Common.safeNumber(id) + Joove.Common.safeNumber(1);taskNode.WpId = wp?.Id;taskNode.TaskId = task?.Id;taskNode.Type = "Task";taskNode.ItemNumber = task?.Number;taskNode.Name = task?.Name;taskNode.StartMonth = task?.StartMonth;taskNode.EndMonth = task?.EndMonth;taskNode.DescriptionOfWork = task?.DescriptionOfWork;taskNode.Objectives = task?.Objectives;taskNode.TotalParentEffort = wp?.TotalPersonMonthsBudgeted;taskNode.TotalPersonMonthsBudgeted = task?.TotalPersonMonthsBudgeted;taskNode.Percentage = task?.TaskPercentage;taskNode.ClickUpListId = task?.ClickUpListId;taskNode.ClickUpLink = task?.ClickUpUrl;taskNode.ItemNumberInt = Domain.ProjectTask.GetNumberInt(task);if ((CLMS.Framework.Number.GreaterThan(() => task.Assignments.length, () => 0))) {taskNode.Leader = task?.Assignments?.linq?.where((a) => a?.IsLeader)?.firstOrDefault(null)?.Participant?.Caption;taskNode.Participants = CLMS.Framework.String.Join(", ", task?.Assignments?.linq?.select((a) => a?.Participant?.Caption)?.toArray());}taskNode.Percentage = task?.TaskPercentage;taskNode.label = task?.Caption;taskNode.StartDate = task?.StartDate;taskNode.EndDate = task?.EndDate;Domain.WorkplanItem.setWorkAssignments(taskNode, task?.Assignments?.linq?.orderBy((a) => a?.Participant?.Caption)?.toArray());wpNode?.children?.add(taskNode);for (let _isubtask = 0; _isubtask < (task?.SubTasks == null ? 0 : task?.SubTasks.length); _isubtask++) {let subtask = task?.SubTasks[_isubtask];let subtaskNode = new Domain.WorkplanItem();subtaskNode.Id = id;id = Joove.Common.safeNumber(id) + Joove.Common.safeNumber(1);subtaskNode.WpId = wp?.Id;subtaskNode.TaskId = task?.Id;subtaskNode.SubtaskId = subtask?.Id;subtaskNode.Type = "Subtask";subtaskNode.ItemNumber = subtask?.Number;subtaskNode.Name = subtask?.Name;subtaskNode.StartMonth = subtask?.StartMonth;subtaskNode.EndMonth = subtask?.EndMonth;subtaskNode.DescriptionOfWork = subtask?.DescriptionOfWork;subtaskNode.Objectives = subtask?.Objectives;subtaskNode.TotalParentEffort = wp?.TotalPersonMonthsBudgeted;subtaskNode.TotalPersonMonthsBudgeted = subtask?.TotalPersonMonthsBudgeted;subtaskNode.Percentage = subtask?.TaskPercentage;subtaskNode.ClickUpListId = subtask?.ClickUpListId;subtaskNode.ClickUpLink = subtask?.ClickUpUrl;subtaskNode.ItemNumberInt = Domain.ProjectTask.GetNumberInt(subtask);if ((CLMS.Framework.Number.GreaterThan(() => subtask.Assignments.length, () => 0))) {subtaskNode.Leader = subtask?.Assignments?.linq?.where((a) => a?.IsLeader)?.firstOrDefault(null)?.Participant?.Caption;subtaskNode.Participants = CLMS.Framework.String.Join(", ", subtask?.Assignments?.linq?.select((a) => a?.Participant?.Caption)?.toArray());}subtaskNode.Percentage = subtask?.TaskPercentage;subtaskNode.label = subtask?.Caption;subtaskNode.StartDate = subtask?.StartDate;subtaskNode.EndDate = subtask?.EndDate;Domain.WorkplanItem.setWorkAssignments(subtaskNode, subtask?.Assignments?.linq?.orderBy((a) => a?.Participant?.Caption)?.toArray());taskNode?.children?.add(subtaskNode);}}}
return nodes;
}
static IsActiveDuringPeriod($this: any, periodStart: any,periodEnd: any): any{return Domain.Util.DoMonthPeriodsOverlap(new Date(new Date(periodStart)?.setHours(0, 0, 0, 0)), new Date(new Date(periodEnd)?.setHours(0, 0, 0, 0)), new Date(new Date($this?.StartDate)?.setHours(0, 0, 0, 0)), new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0)));
}
static IsActiveOnDate($this: any, dt: any): any{return Domain.Util.IsDateWithinPeriod(dt, new Date(new Date($this?.StartDate)?.setHours(0, 0, 0, 0)), new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0)));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}